import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import { FacebookLoginProvider } from '@/helpers/entities/classes/providers/FacebookLoginProvider';
import { UserType } from '@/helpers/entities/enums/UserType';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import BaseText from '@/components/BaseText.vue';
// Initialize class FacebookLoginProvider
const Provider = new FacebookLoginProvider();
let FbLoginButton = class FbLoginButton extends Mixins(GraphqlErrorMixin) {
    constructor() {
        super(...arguments);
        this.validTypes = Object.values(UserType);
    }
    get isAffiliate() {
        return this.userType === UserType.Affiliate;
    }
    get signInWithBasicPersmissions() {
        return this.userType === UserType.StoreManager;
    }
    openFbLoginDialog() {
        if (!this.validTypes.includes(this.userType)) {
            this.hasError();
            this.logError("Something went wrong. Please try again later");
            return;
        }
        Provider.signIn(this.signInWithBasicPersmissions).then((response) => {
            if (response.status === 'connected') {
                /**
                 * Trigger Facebook Login Mutation if User is Successfully
                 *  Authenticated.
                 * https://developers.facebook.com/docs/facebook-login/web
                 */
                const token = response.authResponse.accessToken;
                this.$emit('omniauth:success', token);
            }
        });
    }
};
__decorate([
    Prop()
], FbLoginButton.prototype, "styles", void 0);
__decorate([
    Prop({ required: true })
], FbLoginButton.prototype, "userType", void 0);
FbLoginButton = __decorate([
    Component({
        components: { BaseText },
        mounted() {
            // Call #initialize function to append facebook sdk into DOM head
            Provider.initialize();
        },
    })
], FbLoginButton);
export default FbLoginButton;
